import { useEffect, useRef, useContext } from "react";
import style from "./style.module.css";
import { useSyncedStore } from "@syncedstore/react";
import store from "../../store";
import { Xwrapper } from "react-xarrows";
import Select from "react-select";

import Toolbar from "../../components/Toolbar/index";

import { initThree } from "../../three";

import Node from "../../components/Node";
import UIContext from "../../store/UIContext";
import components from "../../nodes";
import ComputeContext from "../../store/ComputeContext";

function Home() {
  const { state: ComputeState, methods: ComputeMethods } =
    useContext(ComputeContext);
  const { state: UIState, methods: UIMethods } = useContext(UIContext);
  const nodes = useSyncedStore(store.nodes);

  const canvas = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (canvas.current) {
        initThree(canvas.current);
        ComputeMethods.setSceneLoaded(true);
      }
    }, 10);
  }, []);

  const options = components.map((component) => ({
    value: component.name,
    label: component.name,
  }));

  const customStyles = {
    container: (provided, s) => ({
      ...provided,
      width: "200px",
      position: "absolute",
      left: UIState.mousePos.x,
      top: UIState.mousePos.y,
      zIndex: 1,
    }),
  };

  return (
    <div id="bounding" className={style.home}>
      <Toolbar></Toolbar>
      {UIState.showSearchInput && (
        <Select
          placeholder="Search"
          autoFocus
          onBlur={() => UIMethods.setShowSearchInput(false)}
          onChange={({ value }) => {
            UIMethods.addNode(value);
            UIMethods.setShowSearchInput(false);
          }}
          styles={customStyles}
          options={options}
        />
      )}
      <canvas
        onDoubleClick={(e) => {
          UIMethods.setMousePos({ x: e.clientX, y: e.clientY });
          UIMethods.setShowSearchInput(true);
        }}
        style={{ position: "absolute", left: 0, top: 0 }}
        ref={canvas}
      ></canvas>
      {ComputeState.sceneLoaded && (
        <div>
          <Xwrapper>
            {nodes.map((node) => (
              <Node key={node.id} node={node}></Node>
            ))}
          </Xwrapper>
        </div>
      )}
    </div>
  );
}

export default Home;
